<template>
  <div class="documentList-lxr">
    <div class="documentContent">
      <div class="inner">
        <div class="documentInner">
          <div class="screenTop">
            <p class="title">联系人管理</p>
            <!-- -->
            <div class="screenContent">
              <span class="name">快速检索</span>
              <el-input v-model="documentTitle" class="screenInput" placeholder="姓名、企业名称和手机号"></el-input>
              <el-button type="warning" style="margin-left: 30px" class="button" @click="getData(documentTitle)">搜索
              </el-button>
              <el-button class="button" @click="cz">重置</el-button>
            </div>
          </div>
          <div class="documentListContent">
            <div class="topButtons">
              <div class="addBtn" @click="addnew"><i>+</i>新增联系人</div>
              <div class="del" @click="delAll">删除</div>
              <el-table
                v-if="tableData.length>0"
                :data="tableData"
                class="lxrTable"
                style="width: 100%;text-align:center"
                :default-sort="{prop: 'date', order: 'descending'}"
                @selection-change="handleSelectionChange"
              >
                <el-table-column
                  type="selection"
                  width="55">
                </el-table-column>
                <el-table-column
                  label="用户"
                  width="100">
                  <template slot-scope="scope">
                    <span style="font-size: 12px">{{scope.row.companyName}}</span>
                    <!--<span style="font-size: 12px">{{scope.row.name == '' ? scope.row.companyName : scope.row.name}}</span>-->
                  </template>
                </el-table-column>
                <el-table-column
                  prop="phone"
                  label="手机号码"
                  width="100">
                </el-table-column>
                <el-table-column
                  prop="card"
                  label="证件号码">
                </el-table-column>
                <el-table-column
                  prop="cagetory"
                  label="用户类型"
                  >
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="经办人"
                  >
                  <template slot-scope="scope">
                    <span style="font-size: 12px">{{scope.row.cagetory=='个人'?'空':scope.row.name}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="实名状态"
                  >
                  <template slot-scope="scope">
                    <span style="font-size: 12px">{{scope.row.isReal == 1 ? '是' : '否'}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="email"
                  label="电子邮箱">
                </el-table-column>
                <el-table-column
                  label="操作">
                  <template slot-scope="scope">
                    <span class="tableBtn" @click="edit(scope)">编辑</span>
                    <span class="tableBtn" @click="del(scope)">删除</span>
                  </template>
                </el-table-column>
              </el-table>
              <p style="font-size: 18px;text-align: center;line-height: 250px" v-if="tableData.length==0">暂无联系人</p>
            </div>
            <el-pagination
              v-if="tableData.length>0"
              @current-change="handleCurrentChange"
              :page-size="20"
              layout="prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <div class="newLxr" v-show="showWindow">
      <div class="lxrInner">
        <p class="title">{{lxrTitle}}<span class="closeBtn" @click="showWindow = false"></span></p>
        <div class="se1" style="margin-bottom: 20px">
          <div class="name">联系人类型:</div>
          <el-radio v-model="radio" label="0">个人</el-radio>
          <el-radio v-model="radio" label="1">企业</el-radio>
        </div>
        <div class="se1">
          <div class="name"><i>*</i>{{radio == 0 ? '姓名:' : '企业名称:'}}</div>
          <el-input v-model="nname" :placeholder="'请输入'+(radio==0?'姓名:':'企业名称:')"></el-input>
        </div>
        <div class="se1" v-if="radio==1">
          <div class="name"><i>*</i>经办人</div>
          <el-input v-model="username" placeholder="请输入经办人名称"></el-input>
        </div>
        <div class="se1">
          <div class="name"><i>*</i>手机号:</div>
          <el-input v-model="ntel" placeholder="请输入手机号"></el-input>
        </div>
        <div class="se1">
          <div class="name"><i>*</i>{{radio == 0 ? '身份证号' : '统一社会信用代码'}}:</div>
          <el-input v-model="nyy" :placeholder="'请输入'+(radio==0?'身份证号':'统一社会信用代码')"></el-input>
        </div>
        <div class="se1" style="padding-bottom: 20px;
          border-bottom: 1px solid rgb(237,237,237);">
          <div class="name"><i>*</i>电子邮箱:</div>
          <el-input v-model="ne" placeholder="请输入电子邮箱"></el-input>
        </div>
        <div class="btns">
          <div class="btn" @click="sub">确定</div>
          <div class="btn cancel" @click="showWindow = false;nowId = 0;">取消</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
  export default {
    data() {
      return {
        lxrTitle: '新建联系人',
        documentTitle: '',
        name: '',
        date: '',
        showWindow: false,
        radio: '1',
        total: 0,
        nowPage: 0,
        qymc: '',
        nname: '',
        ntel: '',
        nyy: '',
        ne: '',
        tableData: [],
        nowId: 0,
        username: '',
        multipleSelection: [],
        editInfo:null
      }
    },
    methods: {
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      handleCurrentChange(v) {
        this.nowPage = v - 1;
        this.getData();
      },
      createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      getData() {
        let _this = this,
          postdata = {
            page_data : {
              "current_page": _this.nowPage,
              "page_size": 20,
            },
            form_data : {
              "name":_this.documentTitle,
              "type":1
            }
          }
        _this.ajpost('/api/user/findContactsList', postdata, function (datas) {
          console.log(datas)
          _this.tableData = datas.data.list;
          _this.total = datas.data.total;
        }, function (err) {
          console.log(err)
        })
      },
      del(item) {
        let _this = this;
        this.$confirm('您确认要删除该联系人吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _this.ajpost('/api/user/deleteContracts', {list: [item.row.id]}, function (data) {
            if (data.code == 0) {
              _this.$message({
                message: '删除成功',
                type: 'success'
              });
              _this.tableData.splice(item.$index, 1)
            } else {
              _this.$message({
                message: data.data,
                type: 'warning'
              });
            }
          })
        }).catch(() => {
        });
      },
      delAll(){
        var ars = this.multipleSelection.map(item=>item.id)
        console.log(ars)
        let _this = this;
        this.$confirm('您确认要删除所选联系人吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _this.ajpost('/api/user/deleteContracts', {list: ars}, function (data) {
            if (data.code == 0) {
              _this.$message({
                message: '删除成功',
                type: 'success'
              });
              _this.getData()
            } else {
              _this.$message({
                message: data.data,
                type: 'warning'
              });
            }
          })
        }).catch(() => {
        });
      },
      addnew() {
        let _this = this;
        _this.nname = '';
        _this.ntel = '';
        _this.nyy = '';
        _this.ne = '';
        _this.showWindow = true;
      },
      sub() {
        let _this = this,
          url = '/api/user/addContacts',
          edit = _this.nowId != 0;
        if (this.nname == '') {
          this.$message({
            message: _this.radio == 1 ? '请填写企业名称' : '请填写姓名',
            type: 'warning'
          });
        } else if (this.username == '' && this.radio == 1) {
          this.$message({
            message: '请填写经办人名称',
            type: 'warning'
          });
        } else if (this.nyy == '') {
          this.$message({
            message: '请输入' + (_this.radio == 0 ? '身份证号' : '统一社会信用代码'),
            type: 'warning'
          });
        } else if (this.ne == '') {
          this.$message({
            message: '请输入正确的电子邮箱',
            type: 'warning'
          });
        }
        else if (this.ntel == '') {
          this.$message({
            message: '请填写手机号',
            type: 'warning'
          });
        } else {
          let obj = {
            "name": _this.nname,
            "phone": _this.ntel,
            "type": _this.radio,
            "card": _this.nyy,
            "email": _this.ne
          };
          if (edit) {
            url = '/api/user/editContacts';
            obj.id = _this.nowId;
          }
          _this.ajpost(url, obj, function (data) {
              if (data.data.code != 0) {
                _this.$message({
                  message: data.data.msg,
                  type: 'warning'
                });
              } else {
                _this.$message({
                  message: edit ? '修改成功' : '添加成功',
                  type: 'success'
                });
                _this.nowId = 0;
                _this.showWindow = false;
                _this.getData();
              }
            }
          )
        }
      },
      edit(scope) {
        let userInfo = scope.row;
        let _this = this;
        _this.nowId = userInfo.id;
        userInfo.radio = userInfo.cagetory == '企业' ? '1' : '0'
        _this.radio = userInfo.cagetory == '企业' ? '1' : '0'
        _this.nname = userInfo.cagetory == '企业' ? userInfo.companyName :userInfo.name;
          if(userInfo.cagetory == '企业'){
            _this.username = userInfo.name
          }
        _this.editInfo = userInfo;
        _this.ntel = userInfo.phone;
        _this.nyy = userInfo.card;
        _this.ne = userInfo.email;
        _this.showWindow = true;
      },
      cz() {
        this.documentTitle = '';
        this.nowPage = 0;
        this.getData();
      }
    },
    created() {
      let _this = this;
      this.getData();
    },
    watch:{
      radio(){
        let _this = this;
        if(_this.editInfo &&_this.radio!=_this.editInfo.radio){
          _this.nname = ''
          _this.username = ''
          _this.ntel = '';
          _this.nyy = '';
          _this.ne = '';
        }else if(_this.editInfo &&_this.radio==_this.editInfo.radio){
          console.log(_this.editInfo)
          let userInfo = _this.editInfo;
          _this.nname = userInfo.cagetory == '企业' ? userInfo.companyName :userInfo.name;
          if(userInfo.cagetory == '企业'){
            _this.username = userInfo.name
          }
          _this.ntel = userInfo.phone;
          _this.nyy = userInfo.card;
          _this.ne = userInfo.email;
          _this.showWindow = true;
        }
      }
    }
  }
</script>
<style>
  @import "../../assets/less/lxr.css";
</style>



// WEBPACK FOOTER //
// src/components/userCenter/lxr.vue